<template>
  <div v-if="this.$route.name == 'Admin_Businesses'">
    <Navigation
      v-bind:Breadcrumb="[
        { name: 'Home', route: 'Home' },
        { name: 'Staff', route: 'Admin' },
        { name: 'View Businesses', route: 'Admin_Businesses' },
      ]"
    />
    <div class="placeholder">
      <Admin_Businesses_ListDatatable />
    </div>
  </div>
  <div v-else>
    <router-view />
  </div>
</template>

<script>
import { useStore } from "vuex";
import Admin_Businesses_ListDatatable from "@/components/Admin.Businesses.ListDatatable.vue";
import Navigation from "@/components/Navigation.vue";
export default {
  name: "Admin_Businesses",
  setup() {
    const store = useStore();

    return { store };
  },
  components: {
    Navigation,
    Admin_Businesses_ListDatatable,
  },
};
</script>

<style scoped>

</style>